/**
 * Service LEX — dates de dernière synchro (source de vérité côté serveur).
 * Une seule version pour tous les usagers PRIsME master.
 */

const BASE = '/api/prisme/assistant';

export type LexLastSyncDates = Record<string, string>;

export async function getLastSyncDates(): Promise<LexLastSyncDates> {
  const res = await fetch(`${BASE}/last-sync-dates`, { credentials: 'include' });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `GET last-sync-dates: ${res.statusText}`);
  }
  return res.json();
}

export async function saveLastSyncDates(dates: LexLastSyncDates): Promise<LexLastSyncDates> {
  const res = await fetch(`${BASE}/last-sync-dates`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(dates),
  });
  if (!res.ok) {
    const err = await res.json().catch(() => ({ error: res.statusText }));
    throw new Error(err.error || `POST last-sync-dates: ${res.statusText}`);
  }
  return res.json();
}
